// /var/www/devit-dashboard/src/pages/Cualificacion.js
// Página para configurar reglas de cualificación inmobiliaria por tenant

import { useState, useEffect } from 'react';
import { cualificacion as api } from '../services/api';

const TABS = ['Alquiler', 'Compra', 'Venta', 'Arrendar'];

const defaultReglas = {
  alquiler_pedir_nomina:           false,
  alquiler_mascotas:               false,
  alquiler_tipo_contrato:          '',
  alquiler_porcentaje_maximo:      35,
  alquiler_ocupantes_max:          4,
  compra_financiacion_requerida:   false,
  compra_venta_previa:             false,
  venta_comision_porcentaje:       '',
  arrendar_comision_porcentaje:    5.0,
  arrendar_precio_minimo:          0,
  arrendar_documentos_requeridos:  '',
};

export default function Cualificacion() {
  const [tab,     setTab]     = useState('Alquiler');
  const [reglas,  setReglas]  = useState(defaultReglas);
  const [loading, setLoading] = useState(true);
  const [saving,  setSaving]  = useState(false);
  const [msg,     setMsg]     = useState(null); // { type: 'ok'|'err', text }

  // ── Carga inicial ─────────────────────────────────────────────────────────
  useEffect(() => {
    api.get()
      .then(data => setReglas({ ...defaultReglas, ...data }))
      .catch(() => setMsg({ type: 'err', text: 'Error cargando reglas' }))
      .finally(() => setLoading(false));
  }, []);

  // ── Guardar ───────────────────────────────────────────────────────────────
  const handleSave = async () => {
    setSaving(true);
    setMsg(null);
    try {
      await api.update(reglas);
      setMsg({ type: 'ok', text: '✓ Reglas guardadas correctamente' });
    } catch {
      setMsg({ type: 'err', text: 'Error al guardar. Inténtalo de nuevo.' });
    } finally {
      setSaving(false);
    }
  };

  const set = (field, value) => setReglas(prev => ({ ...prev, [field]: value }));

  if (loading) return <div className="page"><p>Cargando...</p></div>;

return (
    <div className="page" style={{ padding: '32px', maxWidth: '800px' }}>
      <div style={{ marginBottom: '24px' }}>
        <h1 style={{ fontSize: '24px', fontWeight: 700, margin: 0, fontFamily: 'inherit' }}>Cualificación</h1>
        <p style={{ color: 'var(--text2)', marginTop: '6px', fontSize: '14px', fontFamily: 'inherit', fontWeight: 400 }}>
          Define qué requisitos debe cumplir un lead según su intención.
          El agente usará estas reglas automáticamente.
        </p>
      </div>

      {/* ── Tabs ─────────────────────────────────────────────────────────── */}
      <div style={{ display: 'flex', gap: '8px', marginBottom: '24px', flexWrap: 'wrap' }}>
        {TABS.map(t => (
          <button
            key={t}
            onClick={() => setTab(t)}
            style={{
              padding: '8px 20px',
              borderRadius: '8px',
              border: '1px solid var(--border)',
              background: tab === t ? 'var(--accent)' : 'var(--bg2)',
              color:      tab === t ? '#fff' : 'var(--text1)',
              cursor: 'pointer',
              fontWeight: tab === t ? 600 : 400,
              fontSize: '14px',
              transition: 'all 0.15s',
            }}
          >
            {t}
          </button>
        ))}
      </div>

      {/* ── Formulario ───────────────────────────────────────────────────── */}
      <div style={{
        background: 'var(--bg2)',
        border: '1px solid var(--border)',
        borderRadius: '12px',
        padding: '24px',
      }}>

        {/* ALQUILER */}
        {tab === 'Alquiler' && (
          <>
            <h3 style={{ marginTop: 0, marginBottom: '20px', fontSize: '16px' }}>Reglas de Alquiler</h3>

            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', fontSize: '13px', color: 'var(--text2)', marginBottom: '6px' }}>
                % máximo del salario destinado al alquiler
              </label>
              <input
                type="number"
                value={reglas.alquiler_porcentaje_maximo || 35}
                onChange={e => set('alquiler_porcentaje_maximo', e.target.value ? parseFloat(e.target.value) : 35)}
                placeholder="Ej: 35"
                min="10"
                max="60"
                step="1"
                style={{
                  width: '100%', padding: '10px 12px', borderRadius: '8px',
                  border: '1px solid var(--border)', background: 'var(--bg3)',
                  color: 'var(--text1)', fontSize: '14px', boxSizing: 'border-box'
                }}
              />
              <small style={{ color: 'var(--text2)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                Estándar del mercado: 30-35%. Con 2.200€ de salario y 35% → máximo 770€/mes de alquiler.
              </small>
            </div>

            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', fontSize: '13px', color: 'var(--text2)', marginBottom: '6px' }}>
                Tipo de contrato preferido
              </label>
              <select
                value={reglas.alquiler_tipo_contrato || ''}
                onChange={e => set('alquiler_tipo_contrato', e.target.value)}
                style={{
                  width: '100%', padding: '10px 12px', borderRadius: '8px',
                  border: '1px solid var(--border)', background: 'var(--bg3)',
                  color: 'var(--text1)', fontSize: '14px', boxSizing: 'border-box'
                }}
              >
                <option value="">Sin preferencia</option>
                <option value="indefinido">Indefinido</option>
                <option value="temporal">Temporal</option>
                <option value="autonomo">Autónomo</option>
              </select>
            </div>

            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', fontSize: '13px', color: 'var(--text2)', marginBottom: '6px' }}>
                Número máximo de ocupantes permitidos
              </label>
              <input
                type="number"
                value={reglas.alquiler_ocupantes_max || ''}
                onChange={e => set('alquiler_ocupantes_max', e.target.value ? parseInt(e.target.value) : null)}
                placeholder="Ej: 4"
                min="1"
                max="20"
                step="1"
                style={{
                  width: '100%', padding: '10px 12px', borderRadius: '8px',
                  border: '1px solid var(--border)', background: 'var(--bg3)',
                  color: 'var(--text1)', fontSize: '14px', boxSizing: 'border-box'
                }}
              />
              <small style={{ color: 'var(--text2)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                Límite de personas que pueden residir en la vivienda.
              </small>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
              <input
                type="checkbox"
                id="pedir_nomina"
                checked={!!reglas.alquiler_pedir_nomina}
                onChange={e => set('alquiler_pedir_nomina', e.target.checked)}
                style={{ width: '16px', height: '16px', cursor: 'pointer' }}
              />
              <label htmlFor="pedir_nomina" style={{ fontSize: '14px', color: 'var(--text1)', cursor: 'pointer' }}>
                Solicitar nómina o justificante de ingresos
              </label>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
              <input
                type="checkbox"
                id="mascotas"
                checked={!!reglas.alquiler_mascotas}
                onChange={e => set('alquiler_mascotas', e.target.checked)}
                style={{ width: '16px', height: '16px', cursor: 'pointer' }}
              />
              <label htmlFor="mascotas" style={{ fontSize: '14px', color: 'var(--text1)', cursor: 'pointer' }}>
                Se permiten mascotas
              </label>
            </div>
          </>
        )}

        {/* COMPRA */}
        {tab === 'Compra' && (
          <>
            <h3 style={{ marginTop: 0, marginBottom: '20px', fontSize: '16px' }}>Reglas de Compra</h3>

            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
              <input
                type="checkbox"
                id="financiacion"
                checked={!!reglas.compra_financiacion_requerida}
                onChange={e => set('compra_financiacion_requerida', e.target.checked)}
                style={{ width: '16px', height: '16px', cursor: 'pointer' }}
              />
              <label htmlFor="financiacion" style={{ fontSize: '14px', color: 'var(--text1)', cursor: 'pointer' }}>
                Preguntar si necesita financiación
              </label>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
              <input
                type="checkbox"
                id="venta_previa"
                checked={!!reglas.compra_venta_previa}
                onChange={e => set('compra_venta_previa', e.target.checked)}
                style={{ width: '16px', height: '16px', cursor: 'pointer' }}
              />
              <label htmlFor="venta_previa" style={{ fontSize: '14px', color: 'var(--text1)', cursor: 'pointer' }}>
                Preguntar si tiene vivienda previa que vender
              </label>
            </div>
          </>
        )}

        {/* VENTA */}
        {tab === 'Venta' && (
          <>
            <h3 style={{ marginTop: 0, marginBottom: '20px', fontSize: '16px' }}>Reglas de Venta</h3>

            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', fontSize: '13px', color: 'var(--text2)', marginBottom: '6px' }}>
                Comisión de la agencia (%)
              </label>
              <input
                type="number"
                value={reglas.venta_comision_porcentaje || ''}
                onChange={e => set('venta_comision_porcentaje', e.target.value ? parseFloat(e.target.value) : null)}
                placeholder="Ej: 3.5"
                step="0.1" min="0" max="100"
                style={{
                  width: '100%', padding: '10px 12px', borderRadius: '8px',
                  border: '1px solid var(--border)', background: 'var(--bg3)',
                  color: 'var(--text1)', fontSize: '14px', boxSizing: 'border-box'
                }}
              />
              <small style={{ color: 'var(--text2)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                El agente informará de esta comisión cuando el lead quiera vender su propiedad.
              </small>
            </div>
          </>
        )}

        {/* ARRENDAR */}
        {tab === 'Arrendar' && (
          <>
            <h3 style={{ marginTop: 0, marginBottom: '20px', fontSize: '16px' }}>Reglas de Arrendamiento</h3>

            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', fontSize: '13px', color: 'var(--text2)', marginBottom: '6px' }}>
                Comisión de gestión (%)
              </label>
              <input
                type="number"
                value={reglas.arrendar_comision_porcentaje ?? ''}
                onChange={e => set('arrendar_comision_porcentaje', e.target.value ? parseFloat(e.target.value) : null)}
                placeholder="Ej: 5"
                step="0.5" min="0" max="100"
                style={{
                  width: '100%', padding: '10px 12px', borderRadius: '8px',
                  border: '1px solid var(--border)', background: 'var(--bg3)',
                  color: 'var(--text1)', fontSize: '14px', boxSizing: 'border-box'
                }}
              />
              <small style={{ color: 'var(--text2)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                Porcentaje que cobra la agencia por gestionar el arrendamiento. El agente lo comunicará al propietario.
              </small>
            </div>

            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', fontSize: '13px', color: 'var(--text2)', marginBottom: '6px' }}>
                Precio mínimo de alquiler aceptado (€/mes)
              </label>
              <input
                type="number"
                value={reglas.arrendar_precio_minimo ?? ''}
                onChange={e => set('arrendar_precio_minimo', e.target.value ? parseFloat(e.target.value) : 0)}
                placeholder="Ej: 500"
                step="50" min="0"
                style={{
                  width: '100%', padding: '10px 12px', borderRadius: '8px',
                  border: '1px solid var(--border)', background: 'var(--bg3)',
                  color: 'var(--text1)', fontSize: '14px', boxSizing: 'border-box'
                }}
              />
              <small style={{ color: 'var(--text2)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                Si el propietario pide menos de este precio, el agente lo marcará como lead de baja prioridad. Pon 0 para sin límite.
              </small>
            </div>

            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', fontSize: '13px', color: 'var(--text2)', marginBottom: '6px' }}>
                Documentos requeridos al arrendatario
              </label>
              <textarea
                value={reglas.arrendar_documentos_requeridos || ''}
                onChange={e => set('arrendar_documentos_requeridos', e.target.value)}
                placeholder="Ej: DNI, últimas 3 nóminas, contrato de trabajo, aval bancario..."
                rows={4}
                style={{
                  width: '100%', padding: '10px 12px', borderRadius: '8px',
                  border: '1px solid var(--border)', background: 'var(--bg3)',
                  color: 'var(--text1)', fontSize: '14px', boxSizing: 'border-box',
                  resize: 'vertical'
                }}
              />
              <small style={{ color: 'var(--text2)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                El agente pedirá estos documentos durante la cualificación.
              </small>
            </div>
          </>
        )}

        {/* ── Guardar ──────────────────────────────────────────────────────── */}
        <div style={{ marginTop: '24px', display: 'flex', alignItems: 'center', gap: '16px' }}>
          
          <button
            onClick={handleSave}
            disabled={saving}
            style={{
              padding: '10px 24px', borderRadius: '8px', border: 'none',
              background: saving ? 'var(--border)' : 'var(--accent)',
              color: '#fff', fontWeight: 600, fontSize: '14px',
              cursor: saving ? 'not-allowed' : 'pointer',
              fontFamily: 'inherit'
            }}
          >
            {saving ? 'Guardando...' : 'Guardar cambios'}
          </button>
          
          {msg && (
            <span style={{ color: msg.type === 'ok' ? '#00d4a0' : '#ff4d4d', fontSize: '14px' }}>
              {msg.text}
            </span>
          )}
        </div>

      </div>
    </div>
  );
}